import React, { FC } from 'react'
import { GuideLines } from '../hooks/document/useTemplateEditorGuides'
import { EditorTheme } from '../templateEditor.theme'
import { toDisplaySize } from '../templateEditor.utils'
import styles from './templateEditor__guideLines.jcss'

type TemplateEditorGuideLinesProps = {
    guides: GuideLines
    theme: EditorTheme
}

export const TemplateEditorGuideLines: FC<TemplateEditorGuideLinesProps> = ({ guides, theme }) => {
    const scale = theme.displayScale

    return (
        <div className={styles.guides} aria-hidden="true">
            {guides.vertical.map((pos) => (
                <div key={`v-${pos}`} className={styles.guideV} style={{ left: toDisplaySize(pos, scale) }} />
            ))}
            {guides.horizontal.map((pos) => (
                <div key={`h-${pos}`} className={styles.guideH} style={{ top: toDisplaySize(pos, scale) }} />
            ))}
        </div>
    )
}
